import { styled } from "styled-components";
const magnitudeMap = /* @__PURE__ */ new Map([
  ["large", [66, 32]],
  ["small", [24, 24]]
]);
const CalendarGrid = styled("div")(
  {
    alignItems: "stretch",
    display: "grid",
    gap: 8,
    justifyContent: "space-around"
  },
  ({ $columns, $magnitude }) => {
    const [width, height] = magnitudeMap.get($magnitude);
    return {
      gridAutoRows: `${height}px`,
      gridTemplateColumns: `repeat(${$columns}, minmax(${width}px, ${width * 2}px))`
    };
  }
);
export {
  CalendarGrid
};
